import React from "react";
import "./our-team.css";

// images
import img1 from "../../images/img1.png";
import img2 from "../../images/img2.png";
import img3 from "../../images/img3.png";
import img4 from "../../images/img4.png";
import img5 from "../../images/img5.png";
import img6 from "../../images/img6.png";
import img7 from "../../images/img7.png";
import img8 from "../../images/img8.png";

import david from "../../images/shangu_updated/David.JPG";
import emperor from "../../images/shangu_updated/shangu_emperor.JPG";
import king from "../../images/shangu_updated/King.JPG";
import queen from "../../images/shangu_updated/Queen.JPG";
import dev from "../../images/shangu_updated/Dev.JPG";
import san from "../../images/shangu_updated/San.JPG";
import whale from "../../images/shangu_updated/Whale.JPG";
import legend from "../../images/shangu_updated/Legend.JPG";

const OurTeam = () => {
    return (
        <div className="our-team" id="ourTeam">
            <div className="our-team-heading">
                <div>
                    <h2>
                        Our <span>Team</span>
                    </h2>
                </div>
            </div>

            <div className="team-box">
                <div className="team-box-1">
                    <img src={david} alt="" />
                    <h3>David Huynh</h3>
                    <h4>Artist</h4>
                    {/* <h4>co-founder - Shangu King</h4> */}
                    <span>
                        <a
                            href="https://Instagram.com/davidhuynh__"
                            target="_blank"
                        >
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a
                            href="https://vm.tiktok.com/ZSebBkfer/"
                            target="_blank"
                        >
                            <i class="fab fa-tiktok"></i>
                        </a>
                    </span>
                </div>
                <div className="team-box-2">
                    <img src={emperor} alt="" />
                    <h3>Shangu Emperor</h3>
                    <h4>Co-founder</h4>
                    {/* <h4>co-founder - Shangu Queen</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-3">
                    <img src={king} alt="" />
                    <h3>Shangu King</h3>
                    <h4>Co-founder</h4>
                    {/* <h4>co-founder - Shangu Dev</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-3">
                    <img src={queen} alt="" />
                    <h3>Shangu Queen</h3>
                    <h4>Co-founder</h4>
                    {/* <h4>co-founder - Shangu Dev</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-4">
                    <img src={dev} alt="" />
                    <h3>Shangu Dev</h3>
                    <h4>Head Developer</h4>
                    {/* <h4>co-founder - Shangu King</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-5">
                    <img src={san} alt="" />
                    <h3>Shangu San</h3>
                    <h4>Ecom Expert</h4>
                    {/* <h4>co-founder - Shangu King</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-5">
                    <img src={whale} alt="" />
                    <h3>Shangu Whale</h3>
                    <h4>NFT Whale</h4>
                    {/* <h4>co-founder - Shangu King</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                <div className="team-box-5">
                    <img src={legend} alt="" />
                    <h3>Crypto Legend</h3>
                    <h4>Blockchain Expert</h4>
                    {/* <h4>co-founder - Shangu King</h4> */}
                    {/* <i className='fab fa-instagram'></i> */}
                </div>
                {/* <div className='team-box-5'>
                    <img src={img8} alt='' />
                    <h3>Shangu</h3>
                    <h4>Blockchain Expert</h4>
                    <h4>co-founder - Shangu King</h4>
                    <i className='fab fa-instagram'></i>
                </div> */}
            </div>
        </div>
    );
};

export default OurTeam;
